import { RadioButton, Title } from "@hiver/hiver-react-component-library";
import { Box, Tooltip } from "@hiver/hiver-ui-kit";
import React from "react";
import {
  FILTER_KEYS,
  OPERATOR_KEYS,
  OPERATOR_RADIO_LABEL_MAP,
} from "../../../constants/conversationFilter";
import { getTagsOperatorsState } from "../utils";
import { tagsDropdownRadioSelectWrapperStyles } from "./styles";

const TagsDropdownRadioSelect = ({
  tagsFilterOperation,
  tagsFilterKey,
  filtersState,
  setTagsOperation,
}) => {
  const onTagsRadioBtnSelect = (operator) => (e) => {
    setTagsOperation({ tagsFilterKey, operator });
  };

  const {
    disableTagsOperator,
    disableWithoutTagsOperator,
  } = getTagsOperatorsState({
    filtersState,
  });

  const disabled =
    tagsFilterKey === FILTER_KEYS.TAGS_FILTER
      ? disableTagsOperator
      : disableWithoutTagsOperator;

  const tooltipText = `Disabled because 'All selected tags' is selected in the 'Tags ${
    tagsFilterKey === FILTER_KEYS.TAGS_FILTER ? "Do not Contain" : "Contain"
  }' section`;

  return (
    <Box sx={tagsDropdownRadioSelectWrapperStyles}>
      <Title type="h5" color="#000">
        Filter conversations with
      </Title>
      {Object.values(OPERATOR_KEYS).map((operation) => {
        const disableRadioButton = disabled && operation === OPERATOR_KEYS.ALL;

        return (
          <Tooltip
            key={operation}
            title={disableRadioButton && tooltipText}
            placement="bottom"
            arrow
            PopperProps={{
              sx: { "&.MuiTooltip-popper": { zIndex: "9999" } },
            }}
          >
            <Box>
              <RadioButton
                value={operation}
                onClick={onTagsRadioBtnSelect(operation)}
                checked={tagsFilterOperation === operation}
                size="sm"
                isInline
                disabled={disableRadioButton}
                checkedColor="#196fe0"
              >
                {OPERATOR_RADIO_LABEL_MAP[operation]}
              </RadioButton>
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default TagsDropdownRadioSelect;
